import { useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { clearStoredAdminConnectorConfig } from "../utils/auth/adminConnectorRuntime";

function getPublicLogoutRedirectUri(path = "/") {
  return new URL(path, window.location.origin).toString();
}

export function useLogout() {
  const { signoutRedirect, clearStaleState, user } = useAuth();

  return useCallback((options = {}) => {
    const tokenToUse = window.token || user?.id_token;
    const uriLogout = getPublicLogoutRedirectUri(options.redirectPath);

    clearStoredAdminConnectorConfig();
    signoutRedirect({
      id_token_hint: tokenToUse,
      post_logout_redirect_uri: uriLogout,
    });
    clearStaleState?.();
  }, [clearStaleState, signoutRedirect, user]);
}
